import * as Util from "../common/util";
import * as Data from "../interfaces/data";
import { ITemplateLinkedCustomerDocument } from "./templateData";

export interface ITaskDetail {
    AppointmentID: number;
    Description: string;
    StatusName: string;
    AppointmentDate: string;
    TemplateName: string;
}

export interface IUserDashboard {
    // Unique ID for the template and template name
    Templates: IUserDashboardTemplate[];

    // Appointment details
    Appointments: ITaskDetail[];
}

export interface IUserDashboardTemplate {
    ID: number;
    Name: string;
    LinkedDocuments: ITemplateLinkedCustomerDocument[];
}
// service calls

export function GetUserDashboard(): JQueryDeferred<Data.IResponse<IUserDashboard>> {
    return Util.callWebService(
        "/api/Appointment/UserDashboard",
        "GET");
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/taskDashboardData.ts